import { clsx } from 'clsx';

// styles
import css from './styles.module.css';

interface IProps {
  className?: string;
}

function Loading({ className }: IProps) {
  return <span className={clsx(css.root, className)}></span>;
}

export default Loading;
